// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__SXG41","gfeWrapper":"CalendarEvent_gfeWrapper__2rfSU"};